// extracted by mini-css-extract-plugin
module.exports = {"addToPageButton":"addToPageButton--8eb8d"};